// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Slice from "../slice"
import * as UserContextSlice from "../../user-context/slice"
import { grpc } from "../../../app/rpc/executor"
import { userCuesServiceClient } from "../../../app/rpc/client"
import { ListUserCuesRequest, ListUserCuesResponse } from "../../../generated/wisetime/user/cues/v4/user_cues_pb"
import { t } from "@lingui/macro"
import { showSnackBar } from "../../snackbar/actions"

type ListUserCuesRpc = (request: ListUserCuesRequest) => Observable<ListUserCuesResponse>

export const listUserCues = (listUserCuesRpc: ListUserCuesRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(UserContextSlice.setUserDetails.match),
      mergeMap(_ => listUserCuesRpc(new ListUserCuesRequest())),
      map(r => r.toObject()),
      map(Slice.setUserCuesList),
      catchError(_ => of(showSnackBar({
        message: t({
          id: "msg_get_user_cues_failed",
          message: "Failed to get user cues. You can ignore this error."
        }),
        messageType: "ERROR",
      })),
      ),
    )

const listUserCuesRpc = (request: ListUserCuesRequest): Observable<ListUserCuesResponse> =>
  grpc(() => userCuesServiceClient.listUserCues(request, null))

export default listUserCues(listUserCuesRpc)
